export default "__VITE_ASSET__DzQlHzE___"